var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.navbarComponent,{tag:"component",attrs:{"username":_vm.username,"current-vertical":_vm.currentVertical,"my-account-url":_vm.myAccountUrl,"main-links":_vm.mainLinks,"user-links":_vm.userLinks,"vertical-links":_vm.verticalLinks,"is-authenticated":_vm.isAuthenticated,"advertiser-id":_vm.advertiserId,"show-favorite":_vm.showFavorite}})
}
var staticRenderFns = []

export { render, staticRenderFns }